import { render } from "./up.vue?vue&type=template&id=64835752&scoped=true"
import script from "./up.vue?vue&type=script&lang=js"
export * from "./up.vue?vue&type=script&lang=js"

import "./up.vue?vue&type=style&index=0&id=64835752&lang=less&scoped=true"
import "./up.vue?vue&type=style&index=1&id=64835752&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64835752"]])

export default __exports__